export const routeStatusTags: { [key: string]: string } = {
    AVAILABLE: 'warning',
    ACCEPTED: 'success',
    CURRENT: 'primary',
    ARRIVED: 'primary',
    HCP_ABORTED: 'danger',
    WITHDRAWN: 'danger',
    CONTROLLER_ABORTED: 'danger',
};
